import React from 'react';
import Icon, { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { useDispatch, useSelector } from "react-redux";
import { setAddTeamMemberView } from "../ducks/add-users.duck";
import { AddTeamMemberView } from "../ducks/AddUsers.model";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ContentCard } from '@shared/ui/atoms/ContentCard';
import { BodySmall } from '@shared/ui/atoms/fonts/Body';
import { Link } from "react-router-dom";
import { selectCurrentUser, selectIsInTeams } from "@shared/store/auth.duck";
import Colours from '@shared/ui/atoms/Colours';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function UserMovedSuccessfully(props: Props) {
  const dispatch = useDispatch();
  const user = useSelector(selectCurrentUser)
  const {t} = useTranslation();
  const showPromotion = (user?.companyEntity.userLimit === 10);
  const isInTeams = useSelector(selectIsInTeams);

  return (
    <>
      <Header>
        <SuccessImage src={"/assets/images/onboarding-invite-sent-image.svg"} />
        <Icon icon={IconTypes.Tick} circle={true} color="blue" size="large"/>
      </Header>
      <HeadlineMedium style={{marginBottom: 24}}>{t('manage.add-new-user.team-member-added')}</HeadlineMedium>

      <OutlineButton fullWidth={true}
                     size={ButtonSize.Large}
                     dataTest="closeMoveTeamMemberDialog"
                     text="button.move-another-user"
                     style={{marginBottom: 16, marginTop: 'auto'}}
                     click={() => dispatch(setAddTeamMemberView(AddTeamMemberView.AddUser))}/>

      <PrimaryButton fullWidth={true}
                     size={ButtonSize.Large}
                     dataTest="closeMoveTeamMemberDialog"
                     text="button.done-for-now"
                     {...(props.onDone ? {click: props.onDone} : {link: "/whereabouts/team"})}/>

      {!isInTeams && showPromotion && <ContentCard style={{marginTop: 48}}>
        <BodySmall weight={600}>{t('did-you-know')}</BodySmall>
        <BodySmall style={{marginBottom: 12}}>{t('manage.add-new-user.paid-account-promote')}</BodySmall>
        <Link to={"/manage/payments"}><BodySmall weight={600} colour={Colours.blue}>{t('manage.add-new-user.upgrade')}</BodySmall></Link>
      </ContentCard>}
    </>
  )
}

interface Props {
  // When set (e.g. inside a dialog), "done" hands control back to the host
  // instead of navigating away.
  onDone?: () => void;
}

const Header = styled.div`
  display: flex;
  flex-direction: column;
  i {
    margin-top: auto;
    margin-bottom: 24px;
  }
  img {
    margin: 0 auto;
  }
`
const SuccessImage = styled.img`
  width: 224px;
  justify-content: center;
`
